import React, { useEffect } from 'react';
import { LoginPreloader } from '../Login/Login';
import {useSelector} from "react-redux";
import {AppState} from "../../types/redux";

export const Logout: React.FC = () => {

	const lastCustId = useSelector<AppState, string>( state => state.customizing.lastId || '');
	useEffect(() => {
		window.location.href = (lastCustId?.toLowerCase()==="bank11" ? '/login' : process.env.REACT_APP_LOGOUT_URL) || '/login';
	}, [lastCustId]);

	return <LoginPreloader message="Sie werden abgemeldet ..." />;
};
